import { Fragment, useMemo, useState } from "react";
import { Badge, Card, Col, Row, Button, Form } from "react-bootstrap";
import HeaderMobile from "../layouts/HeaderMobile";


const mockTimeline = [
  {
    id: "evt-2026-01-10-1",
    category: "GURU",
    company: "AAPL",
    type: "BUY",
    person: "Warren B.",
    title: "투자대가",
    amount: 8.4,
    shares: 240000,
    date: "2026-01-10",
    price: 182.4,
    impact: "중요",
    series: [2.1, 1.6, 0.9, 1.8, 2.0],
  },
  {
    id: "evt-2026-01-05-1",
    category: "FUND",
    company: "MSFT",
    type: "BUY",
    person: "CalPERS",
    title: "연기금",
    amount: 5.2,
    shares: 190000,
    date: "2026-01-05",
    price: 402.1,
    impact: "보통",
    series: [0.6, 0.8, 1.1, 1.0, 1.7],
  },
  {
    id: "evt-2025-12-18-1",
    category: "INSIDER",
    company: "NVDA",
    type: "SELL",
    person: "CEO J. Lee",
    title: "내부자",
    amount: 6.8,
    shares: 90000,
    date: "2025-12-18",
    price: 191.9,
    impact: "높음",
    series: [1.8, 1.6, 1.2, 1.0, 1.2],
  },
  {
    id: "evt-2025-12-04-1",
    category: "INSIDER",
    company: "TSLA",
    type: "BUY",
    person: "VP S. Choi",
    title: "내부자",
    amount: 0.6,
    shares: 18000,
    date: "2025-12-04",
    price: 171.3,
    impact: "보통",
    series: [0.2, 0.1, 0.15, 0.05, 0.1],
  },
  {
    id: "evt-2025-11-29-1",
    category: "GURU",
    company: "AMZN",
    type: "BUY",
    person: "M. Dalio",
    title: "투자대가",
    amount: 3.3,
    shares: 110000,
    date: "2025-11-29",
    price: 156.7,
    impact: "보통",
    series: [0.4, 0.9, 0.7, 0.6, 0.7],
  },
];

export default function StockInsiderTimelineMock() {
  const [selectedId, setSelectedId] = useState(mockTimeline[0].id);
  const [activeCategory, setActiveCategory] = useState("ALL");
  const filteredTimeline = useMemo(() => {
    if (activeCategory === "ALL") return mockTimeline;
    return mockTimeline.filter((item) => item.category === activeCategory);
  }, [activeCategory]);

  return (
    <Fragment>
      <HeaderMobile />
      <div className="p-4 p-lg-5">
        <Row className="g-4">
          <Col xl="12">
            <Card className="mb-4">
              <Card.Body className="p-3 p-md-4">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="ri-file-list-3-line fs-5 text-primary"></i>
                  <h5 className="mb-0">매수/매도 타임라인</h5>
                  <Badge bg="light" text="dark" className="ms-2">
                    최근 90일
                  </Badge>
                </div>

                <Row className="g-3 align-items-center mb-3">
                  <Col md="6">
                    <div className="d-flex gap-2 flex-wrap">
                      <Button
                        variant={activeCategory === "ALL" ? "primary" : "outline-primary"}
                        size="sm"
                        onClick={() => setActiveCategory("ALL")}
                      >
                        전체
                      </Button>
                      <Button
                        variant={activeCategory === "GURU" ? "primary" : "outline-primary"}
                        size="sm"
                        onClick={() => setActiveCategory("GURU")}
                      >
                        투자대가
                      </Button>
                      <Button
                        variant={activeCategory === "FUND" ? "primary" : "outline-primary"}
                        size="sm"
                        onClick={() => setActiveCategory("FUND")}
                      >
                        연기금
                      </Button>
                      <Button
                        variant={activeCategory === "INSIDER" ? "primary" : "outline-primary"}
                        size="sm"
                        onClick={() => setActiveCategory("INSIDER")}
                      >
                        내부자
                      </Button>
                    </div>
                  </Col>
                  <Col md="6">
                    <Form className="d-flex justify-content-md-end gap-2 align-items-center">
                      <Form.Select size="sm" style={{ maxWidth: 160, minHeight: 32 }}>
                        <option>규모 높은 순</option>
                        <option>최근 순</option>
                        <option>직책별</option>
                      </Form.Select>
                      <Form.Select size="sm" style={{ maxWidth: 160, minHeight: 32 }}>
                        <option>1주</option>
                        <option>1개월</option>
                        <option>3개월</option>
                      </Form.Select>
                    </Form>
                  </Col>
                </Row>

                <div className="d-flex flex-column gap-3">
                  {filteredTimeline.map((item) => {
                    const isSelected = item.id === selectedId;
                    const isBuy = item.type === "BUY";
                    const accent = isBuy ? "success" : "danger";
                    return (
                      <div
                        key={item.id}
                        role="button"
                        tabIndex={0}
                        onClick={() => setSelectedId(item.id)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter") setSelectedId(item.id);
                        }}
                        className={`border rounded-3 p-3 ${isSelected ? "bg-light" : ""}`}
                        style={{ cursor: "pointer" }}
                      >
                        <Row className="g-2 align-items-center">
                          <Col xs="auto">
                            <div
                              className={`rounded-pill bg-${accent}-subtle text-${accent} px-3 py-2 text-center d-flex align-items-center justify-content-center`}
                              style={{ minWidth: 76, minHeight: 34 }}
                            >
                              <strong>{isBuy ? "매수" : "매도"}</strong>
                            </div>
                          </Col>
                          <Col>
                            <div className="fw-semibold">
                              {item.title} · {item.person}
                            </div>
                            <div className="text-secondary fs-sm">
                              {item.company} · {item.date} · {item.shares.toLocaleString()}주 · ${item.price.toFixed(2)}
                            </div>
                          </Col>
                          <Col xs="auto" className="text-end d-flex flex-column align-items-end gap-1">
                            <div className="fw-semibold">{item.amount}M</div>
                            <Badge bg={accent} className="text-white" style={{ minWidth: 56 }}>
                              {item.impact}
                            </Badge>
                          </Col>
                        </Row>

                        {isSelected && (
                          <div className="mt-3">
                            <div className="d-flex align-items-center gap-2 mb-2">
                              <i className="ri-line-chart-line text-info"></i>
                              <span className="fw-semibold">이벤트 주가 흐름</span>
                              <Badge bg="info" className="ms-1">D-30 ~ D+30</Badge>
                            </div>
                            <div className="border rounded-3 p-3" style={{ background: "rgba(13, 110, 253, 0.05)" }}>
                              <svg viewBox="0 0 640 180" width="100%" height="180" role="img" aria-label="가격 차트">
                                <rect x="0" y="0" width="640" height="180" fill="transparent" />
                                <line x1="40" y1="10" x2="40" y2="160" stroke="#cbd5e1" strokeWidth="1" />
                                <line x1="40" y1="160" x2="620" y2="160" stroke="#cbd5e1" strokeWidth="1" />
                                <path
                                  d="M40 140 L100 130 L160 135 L220 120 L280 125 L340 100 L400 110 L460 95 L520 100 L580 85 L620 80"
                                  fill="none"
                                  stroke="#0d6efd"
                                  strokeWidth="3"
                                />
                                <line x1="360" y1="10" x2="360" y2="160" stroke="#dc3545" strokeDasharray="6 4" />
                                <circle cx="360" cy="100" r="5" fill="#dc3545" />
                                <text x="368" y="28" fontSize="12" fill="#dc3545">
                                  이벤트
                                </text>
                              </svg>
                              <div className="d-flex justify-content-between text-secondary fs-sm mt-2">
                                <span>D-30</span>
                                <span>D0</span>
                                <span>D+30</span>
                              </div>
                            </div>

                            <div className="mt-3">
                              <div className="d-flex align-items-center gap-2 mb-2">
                                <i className="ri-bar-chart-box-line text-success"></i>
                                <span className="fw-semibold">매수/매도 규모 추이</span>
                              </div>
                              <div className="border rounded-3 p-3" style={{ background: "rgba(25, 135, 84, 0.06)" }}>
                                <svg viewBox="0 0 320 120" width="100%" height="120" role="img" aria-label="매수/매도 차트">
                                  <rect x="0" y="0" width="320" height="120" fill="transparent" />
                                  <line x1="20" y1="10" x2="20" y2="100" stroke="#cbd5e1" strokeWidth="1" />
                                  <line x1="20" y1="100" x2="300" y2="100" stroke="#cbd5e1" strokeWidth="1" />
                                  {item.series.map((value, index) => (
                                    <rect
                                      key={`${item.id}-bar-${index}`}
                                      x={36 + index * 48}
                                      y={100 - value * 40}
                                      width="22"
                                      height={value * 40}
                                      fill={isBuy ? "#198754" : "#dc3545"}
                                      opacity="0.75"
                                    />
                                  ))}
                                </svg>
                                <div className="d-flex justify-content-between text-secondary fs-sm mt-2">
                                  <span>과거</span>
                                  <span>현재</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
}
